<script setup>
    import { CurrencyDollarIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <CurrencyDollarIcon />
</template>
